import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { StatusChip, PaceFlag, GradeBadge } from "@/components/Badges";
import { Link } from "react-router-dom";
import { MyKRA } from "@/pages/admin/AdminWidgets";

export default function PORegister() {
  const { t } = useLang();
  const [pos, setPos] = useState([]);
  const [q, setQ] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  useEffect(() => {
    const params = {};
    if (statusFilter) params.status = statusFilter;
    api.get("/pos", { params }).then((r) => setPos(r.data));
  }, [statusFilter]);

  const filtered = pos.filter((p) =>
    !q || (p.po_number || "").toLowerCase().includes(q.toLowerCase()) || (p.weaver_name || "").toLowerCase().includes(q.toLowerCase())
  );

  const exportCsv = () => {
    const headers = ["PO", "Weaver", "Category", "Status", "ETA", "% Complete", "Pace"];
    const rows = filtered.map((p) => [p.po_number, p.weaver_name, p.product_category, p.status, p.eta || "", p.percent_complete, p.pace_flag]);
    const csv = [headers, ...rows].map((r) => r.map((c) => `"${(c ?? "").toString().replace(/"/g, '""')}"`).join(",")).join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = "po_register.csv"; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div>
      <div className="eyebrow">{t("nav_po_register")}</div>
      <div className="flex items-center justify-between flex-wrap gap-2">
        <h1 className="text-2xl font-bold" style={{ color: "var(--brand-navy)" }}>{t("nav_po_register")}</h1>
        <div className="flex gap-2">
          <input data-testid="po-search" placeholder="Search PO / weaver" value={q} onChange={(e) => setQ(e.target.value)} className="h-10 px-2 border border-[#1B3A5C]/15 rounded-md text-sm" />
          <select data-testid="po-status-filter" value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} className="h-10 border border-[#1B3A5C]/15 rounded-md px-2 text-sm">
            <option value="">All statuses</option>
            {["Draft - ETA Missing", "Pending Inspector Assignment", "Issued", "Raw Material Issued", "In Progress (Daura)", "Final QC", "Received", "Closed"].map((s) => <option key={s}>{s}</option>)}
          </select>
          <button data-testid="export-csv-btn" onClick={exportCsv} className="h-10 px-3 rounded-md border border-[#1B3A5C]/15 text-sm">{t("export_excel")}</button>
        </div>
      </div>
      <div className="mt-4"><MyKRA /></div>
      <div className="overflow-x-auto hag-scroll mt-4">
        <table className="w-full text-sm hag-surface">
          <thead className="bg-[#FAF6F0] text-[#4A627A] uppercase text-xs tracking-widest">
            <tr>
              <th className="text-left p-3">PO</th>
              <th className="text-left p-3">Weaver</th>
              <th className="text-left p-3">Category</th>
              <th className="text-left p-3">Status</th>
              <th className="text-left p-3">ETA</th>
              <th className="text-left p-3">%</th>
              <th className="text-left p-3">Pace</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((p) => (
              <tr key={p.id} data-testid={`po-row-${p.po_number}`} className="border-t border-[#1B3A5C]/5">
                <td className="p-3 font-semibold"><Link to={`/po/${p.id}`} className="text-[#1B3A5C]">{p.po_number}</Link></td>
                <td className="p-3">{p.weaver_name}</td>
                <td className="p-3 text-xs">{p.product_category}</td>
                <td className="p-3"><StatusChip status={p.status} /></td>
                <td className="p-3">{p.eta ? new Date(p.eta).toLocaleDateString() : "—"}</td>
                <td className="p-3">{p.percent_complete}%</td>
                <td className="p-3"><PaceFlag flag={p.pace_flag} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
